import React, { ComponentType } from 'react';

import useShouldShowWhatsappVerification from '../common/hooks/useShouldShowWhatsappVerification';
import ContainerV2 from '../components/ContainerV2';
import { WhatsappVerificationForm } from '../modules/CompanyOnboarding/CompanyCreationPage/components/WhatsappVerification/WhatsappVerificationForm';

export function withVerifyWhatsapp<P = Record<string, unknown>>(
  WrappedComponent: ComponentType<P>
) {
  const Wrapper = (props: P & JSX.IntrinsicAttributes) => {
    const shouldShowWhatsappVerification = useShouldShowWhatsappVerification();
    if (!shouldShowWhatsappVerification) {
      return <WrappedComponent {...props} />;
    }

    return (
      <ContainerV2>
        <WhatsappVerificationForm />
      </ContainerV2>
    );
  };
  Wrapper.displayName = `withVerifyWhatsapp(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return Wrapper;
}
